import Vuex from 'vuex'
import Vue from 'vue'
import actions from './actions'
import mutations from './mutations'
import getters from './getters'

import AC from '../util/ac'


Vue.use(Vuex)

const store = new Vuex.Store({
  state: {
    logged: false,
    ac: AC(),
    working: 0,
    defines: {},
      productInfo: {}
  },
  getters,
  mutations,
  actions
})

export default store
